import { render, staticRenderFns } from "./FixedCostAreaDetails.vue?vue&type=template&id=47ad7f68&scoped=true&"
import script from "./FixedCostAreaDetails.vue?vue&type=script&lang=js&"
export * from "./FixedCostAreaDetails.vue?vue&type=script&lang=js&"
import style0 from "./FixedCostAreaDetails.vue?vue&type=style&index=0&id=47ad7f68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad7f68",
  null
  
)

export default component.exports